module.exports = __webpack_public_path__ + "img/step1.717e1ca3.png";